import * as ActionTypes from '../ActionTypes';
const initState = {
  
    companiesList: "",
    companies:[],
    updatedCompany: '',
   
};

const CompanyReducer = (state = initState, action) => {
    switch (action.type) {

       

        case ActionTypes.LOAD_COMPANIES_LIST_SUCCESS:
            return {
                ...state,
                companiesList: action.res,
                companies: action.res.data
            };

        case ActionTypes.LOAD_COMPANIES_LIST_ERROR:
            return {
                ...state,
                companiesList: action.res,
                companies: action.res.data
            };
        case ActionTypes.UPDATE_COMPANY_SUCCESS:
            return {
                ...state,
                companiesList: action.res,
                companies: action.res.data,
                updatedCompany: action.res.updatedCompany
            };

        case ActionTypes.UPDATE_COMPANY_ERROR:
            return {
                ...state,
                companiesList: action.res,
                companies: action.res.data
            };
           
        case ActionTypes.CODE_ERROR:
            return {
                ...state,
                companiesList:
                    "There seems to be a problem, please refresh your browser",
            };

        default:
            return state;
    }
};

export default CompanyReducer;
